const ComingSoon = () => {
  return (
    <iframe className="w-screen h-screen" title="404" src="/comingSoon.html" />
  );
};

export default ComingSoon;
